import React from 'react'
import { Descriptions, Drawer, Skeleton, Typography } from '@pankod/refine-antd'
import { useOne } from '@pankod/refine-core'

import { TCommonResponse } from 'src/interfaces/common'
import { ApprovalWorkflow } from '@resources/tanda-tangan-elektronik/penandatanganan-sertifikat/components/ApprovalWorkflow'
import { PengajuanStatusTag } from '@resources/tanda-tangan-elektronik/penandatanganan-sertifikat/components/PengajuanStatusTag'
import { TCertificateTTEGetSubmissionResponse } from '@resources/tanda-tangan-elektronik/penandatanganan-sertifikat/types'

const { Text } = Typography

type TWorkflowProgressDrawerProps = {
  open: boolean
  submissionId: string | null
  onClose: () => void
}

export const WorkflowProgressDrawer: React.FC<TWorkflowProgressDrawerProps> = ({
  open,
  submissionId,
  onClose,
}) => {
  const detailQueryResult = useOne<
    TCommonResponse<TCertificateTTEGetSubmissionResponse>
  >({
    resource: 'certificate-tte-submissions',
    id: submissionId ?? '',
    dataProviderName: 'lms',
    queryOptions: {
      enabled: open && !!submissionId,
    },
  })

  const submission = detailQueryResult.data?.data?.data

  return (
    <Drawer
      open={open}
      title="Progres Tanda Tangan Elektronik (TTE)"
      width={640}
      onClose={onClose}
      destroyOnClose
    >
      {detailQueryResult.isLoading ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : submission ? (
        <div className="flex flex-col gap-4">
          <Descriptions column={2} size="small" bordered>
            <Descriptions.Item label="Nama Diklat" span={2}>
              {submission.namaDiklat}
            </Descriptions.Item>
            <Descriptions.Item label="Nama UPT">
              {submission.namaPenyelenggara}
            </Descriptions.Item>
            <Descriptions.Item label="Status">
              <PengajuanStatusTag isAdmin status={submission.status} />
            </Descriptions.Item>
          </Descriptions>

          <ApprovalWorkflow pengajuan={submission} />
        </div>
      ) : (
        <Text type="secondary">Data workflow tidak ditemukan.</Text>
      )}
    </Drawer>
  )
}
